import React, { useEffect, useState, useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './commonDatePicker.css';

const DatePickerComponent = (props) => {
    let { startDate, onChange, error, label, min, max, disabled = false, uniqueId } = props;

    const [open, setOpen] = useState(false);
    const datePickerRef = useRef(null);

    const stopTyping = e => e.preventDefault();

    // Handle date change with proper validation
    const handleDateChange = (date) => {
        // Check if date is valid and within bounds
        if (date && (!min || date >= min) && (!max || date <= max)) {
            onChange(date);
            setOpen(false); // Close the picker
        } else if (date) {
            // Date is outside bounds, still call onChange but don't close
            onChange(date);
             setOpen(false);
        }
    };

    // Handle input click
    const handleInputClick = () => {
        if (!disabled) {
            setOpen(true);
        }
    };

    // Handle outside click
    const handleClickOutside = () => {
        setOpen(false);
    };

    return (
        <div className={error ? 'anv_dateTimePicker anvInputError' : 'anv_dateTimePicker'}>
            <span className='anvDate_lable' data-label={label}></span>
            <DatePicker
                id={uniqueId}
                ref={datePickerRef}
                minDate={min}
                maxDate={max}
                selected={startDate}
                onChange={handleDateChange}
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/yyyy"
                onKeyDown={stopTyping}
                onPaste={stopTyping}
                disabled={disabled}
                readOnly={disabled}
                open={open}
                onInputClick={handleInputClick}
                onClickOutside={handleClickOutside}
                shouldCloseOnSelect={true}
                preventOpenOnFocus={true}
            />
            {error && (
                <span className="input_drop_error">
                    {error}
                </span>
            )}
        </div>
    );
};

export default DatePickerComponent;


// import React, { useState } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import './commonDatePicker.css';

// const DatePickerComponent = (props) => {
//   const { startDate, onChange, error, label, min, max, disabled = false } = props;

//   const [open, setOpen] = useState(false);

//   const stopTyping = e => e.preventDefault();

//   return (
//     <div className={error ? 'anv_dateTimePicker anvInputError' : 'anv_dateTimePicker'}>
//       <span className='anvDate_lable' data-label={label}></span>
//       <DatePicker
//         selected={startDate}
//         onChange={(date) => {
//           onChange(date);
//           setOpen(false); // force close
//         }}
//         onClickOutside={() => setOpen(false)}
//         onInputClick={() => setOpen(true)}
//         open={open}
//         minDate={min}
//         maxDate={max}
//         dateFormat="dd/MM/yyyy"
//         placeholderText="dd/mm/yyyy"
//         onKeyDown={stopTyping}
//         onPaste={stopTyping}
//         disabled={disabled}
//         // readOnly
//       />
//       {error && (
//         <span className="input_drop_error">
//           {error}
//         </span>
//       )}
//     </div>
//   );
// };

// export default DatePickerComponent;


// *************************************************
// initial code
// import React, { useEffect, useState } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import './commonDatePicker.css';

// const DatePickerComponent = (props) => {
//     let { startDate, onChange, error, label, min, max, disabled = false } = props;

//     const [open, setOpen] = useState(false);

//     const stopTyping = e => e.preventDefault();

//     return (
//         <div className={error ? 'anv_dateTimePicker anvInputError' : 'anv_dateTimePicker'}>
//             <span className='anvDate_lable' data-label={label}></span>
//             <DatePicker
//                 minDate={min}
//                 maxDate={max}
//                 selected={startDate}
//                 onChange={(date) => onChange(date)}
//                 dateFormat="dd/MM/yyyy"
//                 placeholderText="dd/mm/yyyy"
//                 onKeyDown={stopTyping}
//                 onPaste={stopTyping}
//                 // onFocus={e => e.target.blur()}
//                 // onClickOutside={() => setOpen(false)}
//                 // onSelect={() => setOpen(false)}
//                 // onInputClick={() => setOpen(true)}
//                 disabled={disabled}
//             />
//             {error && (
//                 <span className="input_drop_error">
//                     {error}
//                 </span>
//             )}
//         </div>
//     );
// };

// export default DatePickerComponent;